import React, { useState, useEffect } from "react";
import { loadStripe } from '@stripe/stripe-js';
import ExpressPay from "./ExpressPay"
import Modal from "../Modal";
import axios from 'axios';

const Checkout = (props) => {
  const [connectedStripeId, setConnectedStripeId] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);

  const stripePublishableKey = 'pk_live_TiFqOMJ1dvtcpK9uQgMAnGHH00h2L4wsks'; //live key
  // const stripePublishableKey = 'pk_test_cIzCaK7wSEWw901sNHD3Biqs008NVxgrAm'; //test key

  const API_URL = "https://do2v45e3qi.execute-api.us-west-2.amazonaws.com/production";
  
  // check what item is being purchased
  let item;
  let itemPrice;
  if(props.itemBeingBought){
    item = props.itemBeingBought === 'payToView' ? 'payToView' : 'download';
    itemPrice = props.itemBeingBought === 'payToView' ?  props.item.watchPrice : props.item.downloadPrice;
  }

  // returns the owner of the vod connectedStripeId
  useEffect(() =>{ 
    (async() => {
      const { data } = await axios.post(`${API_URL}/get-connected-stripe-id`, 
      {
        publicUserId: props.ownerOfVODId
      })
      setConnectedStripeId(data)
    })();
  },[item]);
  
  //create the stripe promise once the connectedStripeId has been returned
  useEffect(() => {
    if( connectedStripeId && !stripePromise){
      setStripePromise(loadStripe(stripePublishableKey, {stripeAccount: connectedStripeId}))
    }
  },[connectedStripeId]);

  return (
    <Modal  {...props} title="Checkout">
      {/* if all values have not loaded, do not render the express component */}
      <ExpressPay 
        item={item}
        stripePromise={stripePromise}
        companyEndpoint={props.companyEndpoint}
        videoId={props.item._id} 
        viewerId={props.viewerId} 
        connectedStripeId={connectedStripeId}/>

      {/* Container for the video purchase description */}
      <ul className="list-group">
        <li className="list-group-item">
          <div className="row">
            <strong className="col">Item</strong>
            <strong className="col">Price</strong>
          </div>
        </li>

        <li className="list-group-item">
          <div className="row">
            {/* video name */}
            <div className="col">
              {props.visible ? props.item.metadata.filename : ""}
            </div>

            {/* Displays the watch price or download price */}
            <div className="col">
              $ {`${itemPrice}.00`}
            </div>
          </div>
        </li>

      </ul>

    </Modal>
  );
}

export default Checkout;
